import { generateWaveformPath } from './generateWaveformPath'

/**
 * Above this rendered width the waveform samples every third peak, below it every fifth — so a card's
 * waveform is not denser than the hero's.
 */
const WIDE_BOX_PX = 650

/**
 * Port of audio-web `getWaveformPath`: the path is built in the box's own pixels, so a bar sits where
 * the reference puts it. Deriving the geometry from a synthetic viewBox and stretching it with
 * `preserveAspectRatio="none"` looks the same only when the scale happens to be 1.
 *
 * An unmeasured box (first client render) draws nothing, as in the reference.
 */
export const getWaveformPath = (svgWidth: number, svgHeight: number, peaks: number[]): string => {
    if (svgWidth === 0 || svgHeight === 0 || peaks.length === 0) {
        return ''
    }

    const divisor = svgWidth > WIDE_BOX_PX ? 3 : 5
    const samplesCount = Math.max(1, Math.floor(peaks.length / divisor))

    return generateWaveformPath(peaks, {
        samplesCount,
        height: svgHeight / 2,
        width: svgWidth,
        type: 'mirror',
        paths: [{ d: 'V', sy: 0, x: 0, ey: 100 }],
    })
}
